import angular from "angular";
import { moduleName as recordModule } from "../../../../records";
import { vsModuleName as lookupModuleName } from "../../../../records/lookup/module";
import { TypeOfAgreementConfig } from "./typeOfAgreement";
import { PerformanceGuaranteeConfig } from "./performanceGuaranteeType";
import { PerformanceGuaranteePartsConfig } from "./performanceGuaranteePartsType";
import { FeeStructureTypeConfig } from "./feeStructureType";
import { FeeStructureConfig } from "./feeStructure";
import { CostTypeConfig } from "./costType";
import { GamingContractConfig } from "./gamingContract";
import { GamingContractMasterAgreementConfig } from "./gamingContractMasterAgreement";
import { vsModuleName as sharedContractModuleName } from "../../../../Contract/shared";
import { PaymentTermConfig } from "./paymentTerm";
import { GamingContractLineItemConfig } from "./gamingContractLineItem";
import { gamingContractMachineConfig } from "./gamingContractMachine";
import { vsObjectName as gamingContractObjectName } from "./gamingContract";
import { contractMachineConfig } from "../../../../Contract/shared/configs/contractMachines";
import { GamingContractMasterAgreementAmendmentConfig } from "./gamingContractMasterAgreementAmendment";

export const vsModuleName = "SlotTrak.ThreeRivers.Configuration";

const module = angular
  .module(vsModuleName, [
    recordModule,
    lookupModuleName,
    sharedContractModuleName,
  ])
  .config(TypeOfAgreementConfig)
  .config(PerformanceGuaranteeConfig)
  .config(PerformanceGuaranteePartsConfig)
  .config(FeeStructureConfig)
  .config(FeeStructureTypeConfig)
  .config(CostTypeConfig)
  .config(PaymentTermConfig)
  .config(GamingContractConfig)
  .config(GamingContractLineItemConfig)
  .config(GamingContractMasterAgreementConfig)
  .config(gamingContractMachineConfig)
  .config(GamingContractMasterAgreementAmendmentConfig)
  .config(contractMachineConfig(gamingContractObjectName));
